import { Component, Inject, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
//import {ToastrService} from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  isNew : boolean;
  itsMe : boolean;
  countryList : string [];
  dialogData :any;
  constructor(public service: UserService,
    //private toastr:ToastrService,
    private gnotify : GlobalNotification,
    public dialogRef: MatDialogRef<RegistrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any) {
      this.dialogData = data;
      this.countryList = GlobalConstants.constCountryArray;
    }

  ngOnInit() {
    this.isNew = (this.service.form.get('id').value == null);
    this.itsMe = (this.service.form.get('id').value == this.service.getUserID());



    this.service.formModel.reset();
  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

/*  onSubmit() {

    this.service.register().subscribe(
      (res: any) => {

        if (res.succeeded) {
          this.service.formModel.reset();
          this.toastr.success("New user created!", "Registration successful");
        }
        else {
          res.errors.forEach(element => {
            switch (element.code) {
              case "DuplicateUserName":

                this.toastr.error("Username is already taken", "Registration failed");
                break;
              default:
                //Registration failed
                this.toastr.error(element.descripiton, "Registration failed");
                break;
            }

          });
        }
      },
        err => {
          console.log(err);
          this.toastr.error(err.descripiton, "Error");
        }
    );

  }
*/
onSubmit() {
  console.log("Create Customer");
//  var error;
//  var result = false;
//  if (this.service.form.valid) {
    if (!this.service.form.get('id').value){

      this.service.register().subscribe(
        res=>{
          //this.service.list.push(res as Customer);
           ////this.toastr.success("Submit successfuly", "Customer Create");
           this.gnotify.showSnackBar('User Create', 'Submit successfuly', "success");
           this.dialogData.result = true;
           this.onClose();
        },
        err=>{
          console.log(err);
          ////this.toastr.error("Failed to Submit", "Customer Create");
          this.gnotify.showSnackBar('User Create', 'Failed to Submit', "error");
          return;
        }
        );
    }
    else{
      this.service.updateData(this.service.form.value).subscribe(
        res=>{
          ////this.toastr.success("Submit successfuly", "User Modify");
          this.gnotify.showSnackBar('User Modify', 'Submit successfuly', "success");
          this.dialogData.result = true;
          this.onClose();
        },
        err=>{
          console.log(err);
          ////this.toastr.error("Failed to Submit", "User Modify");
          this.gnotify.showSnackBar('User Modify', 'Failed to Submit', "error");
          return;
        }
        );
    }

  //}
}

  onClose() {

    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close();
  }
}
